/**
 * DefaultPayoutSection — Default/Generic Owner Payout label for BookingDetailModal
 *
 * Charter: documentation/cursor/Charters/CodeAuditor.md v1.0.1
 * Phase 4b extracted from BookingDetailModal.jsx; JSX and strings unchanged.
 *
 * Purpose:
 *   Render the default/fallback folio label content when no channel-specific branch applies
 *   ("Paid to Owner" with optional payoutLabel parenthetical). Presentational only; parent
 *   passes theme, hostPayout; parent owns predicate flags.
 *
 * Assumptions & Invariants:
 *   - Presentational; no fetch; no admin imports.
 *   - Used only when not VRBO, not CLC Lease, not BookingEngine/Direct/HomeAway, not Airbnb.
 *
 * Dependencies: React only
 *
 * Version: 1.0.0
 *
 * Changelog:
 *   2026-01-27 Phase 4b extraction from BookingDetailModal (default payout label only).
 */

const labelSubtextStyle = {
  fontSize: '12px',
  fontStyle: 'italic',
  opacity: 0.8,
  marginLeft: '4px',
};

/**
 * Renders default/generic Owner Payout label content ("Paid to Owner" + optional payoutLabel).
 * @param {{ theme?: string, hostPayout?: { payoutLabel?: string } }}
 */
export default function DefaultPayoutSection({ theme, hostPayout }) {
  if (hostPayout?.payoutLabel) {
    return (
      <>
        Paid to Owner
        <span style={labelSubtextStyle}>
          ({hostPayout.payoutLabel})
        </span>
      </>
    );
  }
  return 'Paid to Owner';
}
